import React from 'react';
import { Column as ColumnEntity, HeadProps, TableProps } from 'new/elements/Table/types';
import styles from 'new/elements/Table/Table.module.scss';
import { useTableContext } from 'new/elements/Table/useTableContext';
import { Checkbox } from '@mui/material';
import cx from 'classnames';
import { FilterIconButton } from 'new/elements/Table/components/FilterIconButton';
import { SortIconButton } from 'new/elements/Table/components/SortIconButton';

function getRowThClassNames(headClassName, column) {
  return [
    styles.rowTh,
    headClassName,
    column.center ? styles.rowTh_center : '',
    column.numeric ? styles.rowTh_numeric : '',
  ].join(' ');
}

function Column<T>(props: Partial<TableProps<T>> & HeadProps & { column: ColumnEntity<T> }) {
  const { column, headClassName } = props;

  return (
    <div
      className={getRowThClassNames(headClassName, column)}
      style={{ flex: '0 1 ' + column.width + '%' }}
    >
      <div className={cx(styles.columnContent, column.columnClassName)}>
        <span className={styles.columnName}>{column.name}</span>
        <div className={styles.columnActions}>
          <FilterIconButton column={column} />
          <SortIconButton column={column} />
        </div>
      </div>
    </div>
  );
}

function AllRowsCheckBox({ onSelectedRowsChange }) {
  const { allRowsSelected, onSelectAllRows, selectableRows } = useTableContext();

  const onChange = () => {
    onSelectAllRows();
  };

  if (!selectableRows?.length) {
    return null;
  }

  if (!onSelectedRowsChange) {
    return null;
  }

  return <Checkbox checked={allRowsSelected} onChange={onChange} />;
}

export function Head<T>(props: Partial<TableProps<T>> & HeadProps) {
  const {
    columns,
    headClassName,
    onSelectedRowsChange,
    rowCollapsibleRender,
    rowEndRender,
    rows,
    showCheckbox,
  } = props;

  const shouldRenderRowEnd = rowEndRender && rows && rows.length > 0;

  return (
    <div className={[styles.headRow, headClassName].join(' ')}>
      {showCheckbox && <AllRowsCheckBox onSelectedRowsChange={onSelectedRowsChange} />}
      {!!rowCollapsibleRender ? <div className={styles.expandHeadFill} /> : null}
      {columns.map((column, index) => (
        <Column {...props} column={column} key={index} />
      ))}
      {shouldRenderRowEnd ? (
        <div className={styles.rowEndRenderMock}>{rowEndRender(rows[0])}</div>
      ) : null}
    </div>
  );
}
